import styled from 'styled-components'

export const MobileContent = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`

export const WebContent = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`
